import Asyncview from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from '@pixelunion/rimg-shopify';

export default class StaticCart {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');
    this.$quantityInputs = null;
    this.$removeItem = null;
    this.updateTimeout = null;
    $('.cart-instructions textarea').on('change', () => this.saveSpecialInstructions());
    this.initializedClass = 'cart-initialized';
    this._bindCartItemEvents();


    const { hasShippingCalculator } = section.data;

    if (hasShippingCalculator) {
      this.shippingSubmit = this.el.querySelector('[data-shipping-calculator-submit]');
      this.calculateShipping = () => this._calculateShipping();
      this.shippingSelects = this.el.querySelectorAll('.cart-shipping-calculator select');
      this.updateSelects = () => {
        for (let i = 0; i < this.shippingSelects.length; i++) {
          const selectableOption = this.shippingSelects[i];

          const { selectedIndex, options } = selectableOption;
          const { value } = options[selectedIndex];
          const selectedOption = selectableOption.parentElement.firstElementChild;

          selectedOption.innerHTML = value;
        }
      };

      Shopify.Cart.ShippingCalculator.show({
        submitButton: window.Theme.shippingButton,
        submitButtonDisabled: window.Theme.shippingDisabled,
        customerIsLoggedIn: window.Theme.customerLoggedIn,
        moneyFormat: window.Theme.moneyFormat,
      });

      // Wait until DOM load, because jquery.cart.min.js does the same and we rely on that
      $(() => {
        for (let i = 0; i < this.shippingSelects.length; i++) {
          const selectableOption = this.shippingSelects[i];

          selectableOption.addEventListener('change', this.updateSelects);
        }

        this.updateSelects();

        this.shippingSubmit.addEventListener('click', this.calculateShipping);

        if (window.Theme.customerAddress) {
          this._calculateShipping(window.Theme.customerAddress);
        }
      });
    }
  }

  _bindCartItemEvents() {
    this.$quantityInputs = $('[data-quantity-key]', this.$el);
    this.$removeItem = $('[data-remove-item]', this.$el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');

    this.$quantityInputs.each((i, el) => {
      $(el).on('input', (event) => this._updateItemQuantity(event));
    });

    this.$removeItem.each((i, el) => {
      $(el).on('click', (event) => this._updateItemQuantity(event));
    });
  }

  _unbindCartItemEvents() {
    this.$quantityInputs.each((i, el) => {
      $(el).off('input');
    });

    this.$removeItem.each((i, el) => {
      $(el).off('click');
    });

    this.$quantityInputs = null;
    this.$removeItem = null;
  }

  onSectionUnload() {
    this.shippingSubmit.removeEventListener('click', this.calculateShipping);
    for (let i = 0; i < this.shippingSelects.length; i++) {
      this.shippingSelects[i].removeEventListener('change', this.updateSelects);
    }

    $('.cart-instructions textarea').off('change');
  }

  _updateItemQuantity(event) {
    event.preventDefault();

    let $quantityInput;
    let quantity;
    let lineItemKey;

    if (event.currentTarget.hasAttribute('data-remove-item')) {
      quantity = 0;
      lineItemKey = event.currentTarget.dataset.removeItem;
    } else {
      $quantityInput = $(event.currentTarget);
      quantity = $quantityInput.val();
      if (quantity == "") {
        return;
      }
      lineItemKey = $quantityInput.data('quantity-key');
    }

    // cancel any pending requests
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      // Debounce to avoid firing requests while user is still entering number

      const thisTimeoutId = this.updateTimeout;
      window.Shopify.changeItem(lineItemKey, quantity, (cart) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout && this.updateTimeout !== thisTimeoutId) {
          return;
        }
        if (cart.item_count === 0) {
          // reload to show empty cart state
          window.location.reload();
          return;
        }
        this.updateCart(cart, thisTimeoutId);
      });
    }, 300);
  }

  updateCart(cart, timeoutId) {
    const cartCount = cart.item_count;
    $('.cart-count-number').text(cart.item_count);

    // Swap the cart contents to update discount labels.
    Asyncview.load(
      window.Theme.routes.cart_url,
      'ajax',
    )
      .done(({ options, html }) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout !== timeoutId) {
          return;
        }

        this._unbindCartItemEvents();

        // Inject new cart table contents
        const newTableContainer = document.createElement('div');
        newTableContainer.innerHTML = html.table;

        morphdom(
          this.cartTable,
          newTableContainer.querySelector('table'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              // Skip images if src matches
              // - we don't want to reload lazy loaded images
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );

        rimg.watch(this.cartTable);

        // Inject new cart level discounts
        const newDiscountContainer = document.createElement('div');
        newDiscountContainer.innerHTML = html.discounts;
        this.cartDiscountContainer.innerHTML = newDiscountContainer.querySelector('[data-cart-discount-container]').innerHTML;

        // Update total
        this.totalPrice.innerHTML = options.totalPrice;
        this._bindCartItemEvents(this.$el);
      })
      .fail(() => window.location.reload());
  }

  saveSpecialInstructions() {
    const newNote = $('.cart-instructions textarea').val();
    return Shopify.updateCartNote(newNote, (cart) => {
      // empty function so that Shopify's callback isn't invoked
    });
  }

  _calculateShipping(customerAddress) {
    let shippingAddress = {};

    if (customerAddress) {
      shippingAddress = customerAddress;
    } else {
      shippingAddress.country = $('#address_country').val() || '';
      shippingAddress.province = $('#address_province').val() || '';
      shippingAddress.zip = $('#address_zip').val() || '';
    }

    const queryString = Object.keys(shippingAddress)
      .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
      .join('&');

    $.ajax(`/cart/shipping_rates.json?${queryString}`, { dataType: 'json' })
      .fail(error => this._handleErrors(error.responseJSON || {}))
      .done(response => {
        const rates = response.shipping_rates;

        let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
        if (!shippingAddress.province.length) {
          address = `${shippingAddress.zip}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.zip.length) {
          address = `${shippingAddress.province}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.province.length || !shippingAddress.zip.length) {
          address = shippingAddress.country;
        }

        $('.cart-shipping-calculator-response', this.el)
          .empty()
          .append("<p class='shipping-calculator-response message'></p><ul class='shipping-rates'/></ul>");

        const ratesFeedback = $('.shipping-calculator-response', this.el);
        if (rates.length > 1) {
          const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
          const multipleShippingRates = window.Theme.shippingCalcMultiRates
            .replace('--address--', address)
            .replace('--number_of_rates--', rates.length)
            .replace('--rate--', `<span class='money'>${firstRate}</span>`);
          ratesFeedback.html(multipleShippingRates);
        } else if (rates.length === 1) {
          const oneShippingRate = window.Theme.shippingCalcOneRate
            .replace('--address--', address);
          ratesFeedback.html(oneShippingRate);
        } else {
          ratesFeedback.html(window.Theme.shippingCalcNoRates);
        }

        const $cartShippingRates = $('.shipping-rates', this.el);

        for (let i = 0; i < rates.length; i++) {
          const rate = rates[i];
          const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          const rateValues = window.Theme.shippingCalcRateValues
            .replace('--rate_title--', rate.name)
            .replace('--rate--', `<span class='money'>${price}</span>`);

          $cartShippingRates.append(`<li>${rateValues}</li>`);
        }
      });
  }

  _handleErrors(errors) {
    let errorMessage = '';

    if ('zip' in errors) {
      errorMessage = window.Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
    } else {
      errorMessage = errors;
    }

    $('.cart-shipping-calculator-response').html(`<p>${errorMessage}</p>`);
  }
}
